import { TimelineGroupView } from '../view/TimelineGroupView';
import { templateTimelineGroup } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import { TimelineGroupWebComponent } from '..';
import { Alerts, OPEN_GRAPH_EVENT_NAME } from '../types';

export class TimelineGroupController extends BaseWebComponentController {
  public component: TimelineGroupWebComponent;
  public view: TimelineGroupView;
  public viewConstructor: typeof TimelineGroupView;

  constructor(component: TimelineGroupWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: TimelineGroupView,
      viewTemplate: templateTimelineGroup,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$viewOnGraph,
        event: 'click',
        callback: this.viewOnGraphEvent.bind(this),
      },
    ];
  }

  viewOnGraphEvent() {
    this.component.dispatchEvent(
      new CustomEvent(OPEN_GRAPH_EVENT_NAME, {
        bubbles: true,
        composed: true,
      })
    );
  }

  async getDataForView(): Promise<Alerts> {
    return this.component.alertsData;
  }
}
